import { generatePath } from 'react-router-dom';
import { ApiRoutes, Invoice } from 'types';
import { axiosInstance } from './axiosInstance';
import { getApiUrl } from './helpers';

export type FetchInvoicesArgs = {
  period?: string | null;
  campaignId: number | null;
  offset: number;
  limit?: number | null;
  all?: boolean;
};

export type GetInvoicesResponse = {
  invoices: Invoice[];
  total: number;
};

export async function fetchInvoices({ period, campaignId, offset, limit = 10, all = false }: FetchInvoicesArgs) {
  const searchParams = new URLSearchParams();
  if (period) {
    searchParams.append('period', period);
  }
  if (campaignId) {
    searchParams.append('campaignId', campaignId.toString());
  }
  if (offset) {
    searchParams.append('offset', offset.toString());
  }

  if (limit) {
    searchParams.append('limit', limit.toString());
  }

  const path = `${generatePath(all ? ApiRoutes.InvoicesAll : ApiRoutes.Invoices)}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`;
  const { data } = await axiosInstance.get<GetInvoicesResponse>(getApiUrl({ path }));
  return data;
}

export function getInvoiceFileLink(invoiceId: number) {
  const path = `/invoices/${invoiceId}.pdf`;

  return getApiUrl({ path });
}

export async function uploadInvoice(body: FormData) {
  const path = `${generatePath(ApiRoutes.Invoices)}/`;
  await axiosInstance.post(getApiUrl({ path }), body);
}

export async function generateInvoice(data: {
  businessInvoiceId: string;
  amount: string;
  invoiceDate: string;
  campaignId: string;
}) {
  const path = generatePath(ApiRoutes.GenerateInvoice);
  await axiosInstance.post(getApiUrl({ path }), data);
}

export async function markInvoiceAsPaid(invoiceId: number) {
  const path = generatePath(ApiRoutes.MarkInvoiceAsPaid, { invoiceId: String(invoiceId) });
  const { data } = await axiosInstance.post(getApiUrl({ path }));
  return data;
}
